import * as moment from 'moment'

export default {
  data: function () {
    return {
      // SidebaarSelectedMenu: 1
    }
  },
  methods: {
    getImageAWS (item) {
      return `${process.env.S3_URL}/${item}`
    },
    addCommas (amount) {
      let newAmount = amount
      if (newAmount !== '' || newAmount !== undefined || newAmount !== 0 || newAmount !== '0' || newAmount !== null) {
        return newAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return newAmount
    },

    mixGetBlobUrl () {
      let BASE_BLOB
      if (process.env.NODE_ENV === 'development') {
        BASE_BLOB = 'https://demoanchorblobcomp.blob.core.windows.net/'
      } else {
        BASE_BLOB = 'https://andalinfiles.blob.core.windows.net/'
      }
      return BASE_BLOB
    },

    getDateDefauld (date) {
      return moment(date).format('DD MMM YYYY')
    },

    getShipmentType (type) {
      if (type === 'AIRCARGO') {
        return 'Air Cargo'
      } else if (type === 'AIRCOURIER') {
        return 'Air Courier'
      } else {
        return type.split('SEA').join('')
      }
    },

    canAccessAndalinPoints () {
      if (JSON.parse(localStorage.getItem('profile')).andalinPoint === undefined) return true
      else return JSON.parse(localStorage.getItem('profile')).andalinPoint !== 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js